import { useEffect } from 'react'

export default function WastewaterTreatment() {
  useEffect(() => {
    document.title = 'Industrial Wastewater Treatment Equipment Supplier | Yixing'
  }, [])

  return (
    <div className="page">
      <section className="page-header">
        <p className="eyebrow">DEFINED INDUSTRIAL WASTEWATER PACKAGES</p>
        <h1>Industrial Wastewater Treatment Equipment Supply from Yixing</h1>
        <p>Equipment supply is reviewed against the customer's approved process basis, wastewater data and project interfaces—not presented as an undefined turnkey promise.</p>
      </section>

      <section className="page-content">
        <h2>Technical Input</h2>
        <p>Turn process data into a clear equipment scope. A useful RFQ connects the wastewater characteristics and treatment objective to a defined package boundary. Each open point is recorded before configuration and pricing are finalized.</p>

        <h3>01 Wastewater source</h3>
        <p>Describe the production process, discharge pattern, contaminants and whether streams are separated or mixed.</p>

        <h3>02 Design basis</h3>
        <p>Share available flow, peak conditions, water analysis, temperature, pH and the required outlet or downstream treatment standard.</p>
      </section>
    </div>
  )
}
